import { createFileRoute } from '@tanstack/react-router';

/**
 * Задача — панель поверх проекта со своим адресом: на неё ведут уведомления и загрузка. Панель рисует сам
 * проект (`$id.tsx`): так она уезжает плавно, а не пропадает вместе с маршрутом.
 */
export const Route = createFileRoute('/_app/projects/$id/tasks/$taskId')({
  component: () => null,
});
